document.addEventListener('DOMContentLoaded', function() {
    console.log("moxi-post-tokenize.js: Script cargado");
  
    // Evitar ejecución múltiple
    if (window.moxiPostTokenizeInitialized) {
        console.log("moxi-post-tokenize.js: Ya inicializado, saltando...");
    } else {
        window.moxiPostTokenizeInitialized = true;
  
        var checkoutButton;
        var mp_public_key = "";
        var shopId = "";
  
        // Cargar IMask desde CDN (forma oficial según documentación)
        if (typeof IMask === 'undefined') {
            const imaskScript = document.createElement('script');
            imaskScript.src = 'https://unpkg.com/imask';
            document.head.appendChild(imaskScript);
  
            // Esperar a que IMask se cargue antes de ejecutar el código
            imaskScript.onload = function() {
                console.log('IMask loaded successfully');
                initializeApp();
            };
        } else {
            // IMask ya está cargado
            console.log('IMask already loaded');
            initializeApp();
        }
  
        function initializeApp() {
  
            console.log("payment form ready v2");
  
            console.log("DOM fully loaded and parsed");
            
            const form = document.getElementById("payment-form");
            const mp_public_key_element = document.getElementById("mp_public_key");
            const expirationDate = document.getElementById('expirationDate');
            
            // Initialize MercadoPago
            shopId = Shopify.shop;
            mp_public_key = mp_public_key_element.value;
            
           
          
            if (!form) {
                console.error("Form 'payment-form' not found!");
                return;
            }
            
            if (!mp_public_key_element) {
                console.error("MP Public Key element not found!");
                return;
            }
            
            if (!expirationDate) {
                console.error("Expiration Date element not found!");
                return;
            }
            /// Fetch the cart token+
            fetchCartToken();
            initializeSubscriptionButton();
            console.log("payment form ready v2");
            //get param from url called "order"
            const urlParams = new URLSearchParams(window.location.search);
            const order = urlParams.get('order');
            const email = urlParams.get('email');
            console.log("order", order);
            console.log("email", email);
  
            var element = expirationDate;
            var maskOptions = {
                mask: '`m/`YYYY',
                lazy: false,
                blocks: {
                    m: {
                        mask: IMask.MaskedRange,
                        from: 1,
                        to: 12,
                        maxLength: 2,
                        placeholderChar: 'M'
                    },
                    YYYY: {
                        mask: IMask.MaskedRange,
                        from: 2022,
                        to: 9999,
                        placeholderChar: 'A'
                    }
                }
            };
  
            // var mask = IMask(element, maskOptions);
            var mask = IMask(element, maskOptions);
            console.log("mask", mask);
                document.getElementById("btn_mp_token").addEventListener("click", function (event) {
                    console.log('click=======');
                    
                    event.preventDefault();
  
                    const email = document.getElementById("email").value;
                    const cardNumber = document.getElementById("cardNumber").value;
                    const cardHolderName = document.getElementById("cardHolderName").value;
                    const expirationDate = document.getElementById("expirationDate").value;
                    const securityCode = document.getElementById("securityCode").value;
                    const identificationNumber = document.getElementById("identificationNumber").value;
                    
                var exp_date = mask.value;
                var month = exp_date.substring(0, 2);
                var year = exp_date.substring(3);
                
              
                const maskedCardNumber = cardNumber.slice(-4).padStart(cardNumber.length, '*');
                const maskedSecurityCode = securityCode.slice(-1).padStart(securityCode.length, '*');
                const mp = new MercadoPago(mp_public_key, {
                    locale: 'en-US'
                });
                let cartData = {
                    cardNumber: cardNumber,
                    cardholderName: cardHolderName,
                    cardExpirationMonth: month,
                    cardExpirationYear: year,
                    securityCode: securityCode,
                    identificationType: 'CC',
                    identificationNumber: identificationNumber
                };
                const cardToken = mp.createCardToken(cartData);
                document.getElementById("step1").style.display = "none";
                document.getElementById("loadingStep").style.display = "block";
                cardToken.then(result => {
                    console.log("🎉 ¡TOKENIZACIÓN EXITOSA!");
                    console.log("Resultado completo:", result);
                    var cartId = document.getElementById("cartId").value;
                    var dataSubscriptor = {
                        "shopId": shopId,
                        "orderId": "",
                        "cardToken": result.id,
                        "ShopifyCartId": cartId,
                        "docNumber": identificationNumber,
                        "email": email
                    };
                    const endpointUrl = document.querySelector('input[name="endpoint_url"]')?.value || 'https://suscripciones.shopihub.co/api/Suscription/SaveSuscriptionToken';
                    
                    fetch(endpointUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(dataSubscriptor),
                    }).then(async response => {
                        console.log("=== RESPUESTA DEL SERVICIO ===");
                        console.log("servicio:", response);
                        if (response.status === 200) {
                            // Validar y actualizar el atributo type del carrito
                            await ensureCartTypeAttribute();
                            
                            document.getElementById("loadingStep").style.display = "none";
                            document.getElementById("step2").style.display = "block";
                            
                            // Configurar formularios si es necesario
                            const forms = document.querySelectorAll('form[action="/cart"]');
                            forms.forEach(form => {
                                const url = new URL(form.action);
                                url.searchParams.set('checkout[shipping_address][company]', identificationNumber);
                                form.action = url.toString();
                                form.action = decodeURIComponent(form.action);
                            });
                            setTimeout(() => {
                                if (checkoutButton) {
                                    checkoutButton.click();
                                } else {
                                   const returnUrl = document.querySelector('input[name="return_url"]')?.value || '/checkout';
                                    console.log('Redirigiendo a:', returnUrl);
                                    window.location.href = returnUrl;
                                }
                            }, 3000);
                            
                            return; 
                        } else {
                            console.log("ERROR: Status no es 200 - Mostrando error");
                            document.getElementById("loadingStep").style.display = "none";
                            document.getElementById("step2error").style.display = "block";
                            document.getElementById("step2").style.display = "none";
                            return;
                        }
                    })
                    .catch((error) => {
                        // 📋 IMPRIMIR ERROR DETALLADO
                        console.log("=== ERROR EN EL SERVICIO ===");
                        console.log("Error:", error);
                        
                        document.getElementById("loadingStep").style.display = "none";
                        document.getElementById("step2error").style.display = "block";
                        document.getElementById("step2").style.display = "none";
                    });
                   
                }).catch(error => {
                    document.getElementById("loadingStep").style.display = "none";
                    document.getElementById("step2error").style.display = "block";
                    document.getElementById("step2").style.display = "none";
                });
            });
        }
  
        async function fetchCartToken() {
            try {
                const response = await fetch('/cart.js', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                if (!response.ok) {
                    throw new Error('Failed to fetch cart data');
                }
                const cartData = await response.json();
                const cartToken = cartData.token;
                if (cartToken) {
                    document.getElementById('cartId').value = cartToken.split('?')[0];
                    console.log('Cart token:', cartToken);
                } else {
                    console.error('Cart token not found');
                }
            } catch (error) {
                console.error('Error fetching cart token:', error);
            }
        }

        /**
         * Valida y actualiza el atributo type del carrito a "Suscripciones"
         * Si el atributo no existe o tiene un valor diferente, lo actualiza
         */
        async function ensureCartTypeAttribute() {
            try {
                console.log('[MoxiPostTokenize] Validando atributo type del carrito...');
                
                // Obtener el carrito actual
                const response = await fetch('/cart.js', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error('No se pudo leer el carrito');
                }

                const cart = await response.json();
                const currentType = cart.attributes?.type || '';
                
                // Si el atributo ya es "Suscripciones", no hacer nada
                if (currentType === 'Suscripciones') {
                    console.log('[MoxiPostTokenize] El atributo type ya está configurado como "Suscripciones"');
                    return;
                }

                console.log('[MoxiPostTokenize] Actualizando atributo type a "Suscripciones" (valor actual:', currentType, ')');
                
                // Actualizar el atributo del carrito
                const updateResponse = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                        attributes: {
                            type: 'Suscripciones'
                        }
                    })
                });

                if (updateResponse.ok) {
                    const updatedCart = await updateResponse.json();
                    console.log('[MoxiPostTokenize] ✅ Atributo type actualizado exitosamente:', updatedCart.attributes?.type);
                    
                    // Actualizar también el campo del formulario si existe
                    const attributeField = document.querySelector('p.cart-attribute__field input[name="attributes[type]"]');
                    if (attributeField) {
                        attributeField.value = 'Suscripciones';
                        console.log('[MoxiPostTokenize] Campo del formulario actualizado');
                    }
                } else {
                    const errorText = await updateResponse.text();
                    console.error('[MoxiPostTokenize] Error actualizando atributo type:', errorText);
                }
            } catch (error) {
                console.error('[MoxiPostTokenize] Error en ensureCartTypeAttribute:', error);
            }
        }

  
        function showPopup() {
            document.getElementById('mercadoPagoPopup').style.display = 'block';
        }
  
        function closePopup() {
            document.getElementById('mercadoPagoPopup').style.display = 'none';
        }
  
        function initializeSubscriptionButton() {
            checkoutButton = document.querySelector('[type="submit"][name="checkout"]');
            const cartTypeElement = document.getElementById('cartType');
            const hasSubscription = cartTypeElement && cartTypeElement.value === 'Suscripciones';
            
            console.log("Checkout button found:", !!checkoutButton);
            console.log("Cart type element found:", !!cartTypeElement);
            console.log("Has subscription:", hasSubscription);
            
            if (hasSubscription && checkoutButton) {
                // Oculta el botón de checkout
                // Crea un botón de "Suscribirse" con el mismo estilo que el botón de checkout
                const subscribeButton = document.createElement('button');
                subscribeButton.type = 'button'; // Asegúrate de que sea de tipo button
                subscribeButton.textContent = 'Suscribirse';
                subscribeButton.className = checkoutButton.className; // Copia las clases del botón de checkout
                subscribeButton.style.cssText = checkoutButton.style.cssText; // Copia los estilos inline del botón de checkout
                subscribeButton.addEventListener('click', function () {
                    showPopup();
                });
                // Inserta el botón de "Suscribirse" después del botón de checkout
                if (checkoutButton && checkoutButton.parentNode) {
                    checkoutButton.parentNode.insertBefore(subscribeButton, checkoutButton.nextSibling);
                }
                if (checkoutButton) {
                    checkoutButton.style.display = 'none';
                }
            }
            // Datos de prueba deshabilitados - el usuario llenará los campos manualmente
            // const isTestData = document.getElementById('is_test_data').value === 'true';
            // if (isTestData) {
            //     document.getElementById('cardNumber').value = '5254133674403564';
            //     document.getElementById('cardHolderName').value = 'APRO APRO';
            //     document.getElementById('expirationDate').value = '11/2030';
            //     document.getElementById('securityCode').value = '123';
            //     document.getElementById('identificationNumber').value = '12345678';
            // }
        }
    }
  });